import { UPDATE_ME, UPDATE_TENANT_INFO } from 'src/store/types'
import { ElMessage } from 'element-plus'

const COMMON_ERROR_MESSAGE = '查询失败'
const NET_CODE_401_ERROR_MSG = '没有权限, 请重新登录'

function commonErrorHandler(_, msg) {
  ElMessage({
    message: msg,
    type: 'error',
  })
  return true
}

function axiosErrorHandler(err) {
  if (err.response) {
    if (err.response.status === 401) {
      ElMessage({
        message: NET_CODE_401_ERROR_MSG,
        type: 'error',
      })
      $store.commit(UPDATE_ME, null)
      $store.commit(UPDATE_TENANT_INFO, null)
      $router.replace({
        name: 'Login',
      })
      return true
    }
    if (err.response.status === 403) {
      $router.replace({
        name: 'Dashboard',
      })
    }
    let msg = err.response.data
    if (!(err.config && err.config.fullError)) {
      if (!msg || msg.length > 100) {
        if (err.response.status === 500) {
          msg = '服务器错误'
        } else {
          msg = err.response.status
        }
      }
    }
    if (!(err.config && err.config.ignoreError)) {
      ElMessage({
        message: msg,
        type: 'error',
      })
    }
    return true
  }
  return false
}

const errorHandlers = [
  axiosErrorHandler,
  commonErrorHandler,
]

export function handleError(err, defaultMsg = COMMON_ERROR_MESSAGE) {
  for (const item of errorHandlers) {
    if (item(err, defaultMsg)) {
      break
    }
  }
}
